import React, { useEffect, useState } from "react";
import styles from "./PrivacyPolicy.module.css";
import { useOutletContext } from "react-router-dom";

import { collection, getDoc, getDocs, doc } from "firebase/firestore";
import { db } from "../firebase";
import { fetchAdminContentDoc } from "../utils/adminContent";

function linkifyEmailsInHtml(rawHtml) {
  if (!rawHtml || typeof rawHtml !== "string") return rawHtml || "";
  if (typeof document === "undefined") return rawHtml;

  const emailRegex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
  const container = document.createElement("div");
  container.innerHTML = rawHtml;

  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach((textNode) => {
    const text = textNode.nodeValue || "";
    emailRegex.lastIndex = 0;
    if (!emailRegex.test(text)) return;

    emailRegex.lastIndex = 0;
    const fragment = document.createDocumentFragment();
    let cursor = 0;
    let match = emailRegex.exec(text);

    while (match) {
      const email = match[0];
      const start = match.index;
      if (start > cursor) {
        fragment.appendChild(document.createTextNode(text.slice(cursor, start)));
      }

      const link = document.createElement("a");
      link.href = `mailto:${email}`;
      link.textContent = email;
      fragment.appendChild(link);

      cursor = start + email.length;
      match = emailRegex.exec(text);
    }

    if (cursor < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(cursor)));
    }
    textNode.parentNode?.replaceChild(fragment, textNode);
  });

  return container.innerHTML;
}

const PrivacyPolicy = () => {
  const outlet = useOutletContext();
  const [content2, setContent] = useState({});
  const heading =
    outlet?.text != null
      ? outlet.isRtl
        ? outlet.text.Arabic11
        : outlet.text.Eng11
      : "Privacy Policy";

  useEffect(() => {
    async function getWebsiteContent() {
      try {
        const data = await fetchAdminContentDoc(db, {
          getDoc,
          getDocs,
          collection,
          doc,
        });
        if (data) {
          setContent(data);
        } else {
          console.log("No documents found in the 'admin' collection.");
        }
      } catch (error) {
        console.log("Error: ", error);
      }
    }
    getWebsiteContent();
  }, []);
  const privacyHtml = linkifyEmailsInHtml(content2.privacy_policy);

  return (
    <div className={`${styles.container} ${styles.documentLtr}`} dir="ltr">
      <h1 className={styles.title}>{heading}</h1>
      <div
        className={styles.bodyHtml}
        dangerouslySetInnerHTML={{
          __html: privacyHtml,
        }}
      />
      {/* <ul className={styles.text}>{content2}</ul> */}
      {/* <ul className={styles.text}>
        <li>
          We value your privacy and strive to protect your personal information
          in accordance with all relevant data protection laws and regulations.
        </li>
        <li>
          The data we collect: your name, email, video data, time of uploading,
          its source whether it's a camera, file or YouTube link.
        </li>
        <li>
          The purpose of collecting data: To provide the necessary support to
          our users and improve the service to you.
        </li>
        <li>
          We do not share your personal information with companies,
          organizations or individuals outside the application except in the
          following two cases:
        </li>
        <li>If we get written consent from you.</li>
        <br />
        <li>
          If we believe that access, use, retention, or disclosure of the
          information is necessary to fulfill any applicable law, regulation,
          legal process, or enforceable government request.
        </li>
        <li>
          Your rights: You have the right to access, update and delete your
          personal information at any time by logging into your account.
        </li>
        <li>
          You also have the right to object to our use of your personal
          information and to restrict our handling of it.
        </li>
        <li>
          Change policy: We may change our policy from time to time to reflect
          the change in laws of data collection and use. Please review this
          policy periodically to stay informed of any changes.
        </li>
      </ul> */}
     
    </div>
  );
};

export default PrivacyPolicy;
